import * as React from "react";
const IconCreditCards = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M59.2 18.1v-5.7c0-1.8-.8-3.4-2.2-4.5s-3.2-1.5-4.9-1.1L8.6 17.2H8c-3.4 0-6.2 2.8-6.2 6.2V51c0 3.4 2.8 6.2 6.2 6.2h48c3.4 0 6.2-2.8 6.2-6.2V23.5c0-2.3-1.2-4.3-3-5.4m-6.1-6.9c.5-.1.9.1 1.1.3s.5.5.5 1v4.8H27.9zM8 21.7h48c1 0 1.8.8 1.8 1.8v3.9H6.2v-3.9c0-1 .8-1.8 1.8-1.8m49.8 10.2v4.5H6.2v-4.5zm-1.8 21H8c-1 0-1.8-.8-1.8-1.8V40.9h51.5v10.2c.1 1-.7 1.8-1.7 1.8" />
  </svg>
);
export default IconCreditCards;
